import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import chapterActions from "app/utils/chapterActions";
import alertActions from "app/utils/alertActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import { Feather, FontAwesome } from "@expo/vector-icons";

import Icon from "app/components/Icon";
import Hoverable from "app/components/Hoverable";
import Draggable from "app/components/Draggable";
import Badge from "app/components/chapter/Badge";
import MomentBullet from "app/components/chapter/MomentBullet";
import EventEditor from "app/components/chapter/EventEditor";
import ValueListItem from "app/components/ValueListItem";
import HoverableTooltip from "app/components/HoverableTooltip";
import Tag from "app/components/chapter/Tag";

export default class BadgeRow extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    // button: Component
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      chapter: props.chapter,
      expanded: props.expanded || false,
      selectedMoment: null,
      showMore: false,
    };
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    let {
      moments,
      secondaryValues,
      loading,
      title,
      button,
      maxLength,
      firstButton,
      onPressTitle,
      onDoublePressTitle,
    } = this.props;
    let { selectedMoment, showMore } = this.state;

    let overflowing = !showMore && !!maxLength && moments?.length > maxLength;
    let overflowingBy = !!overflowing ? moments.length - maxLength : 0;

    // console.log(values);

    const scrollable = !ENV.WEB; // || this.props.tags;
    const MaybeScrollView = scrollable ? ScrollView : View;

    if (!moments?.length && !secondaryValues?.length && loading) {
      return null;
    }
    if (
      !!moments?.length ||
      !!secondaryValues?.length ||
      !!firstButton ||
      !!onPressTitle
    ) {
      return (
        <View
          style={[
            styles.topMargin,
            styles.wrapper,
            this.props.wrapperStyle,
            // { zIndex: 99 - (this.props.index || 0) }
          ]}
        >
          <MaybeScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={[
              !scrollable
                ? styles.row
                : {
                    flexGrow: 0,
                  },
              { zIndex: 2 },
            ]}
            contentContainerStyle={{
              ...styles.row,
            }}
          >
            {!!title && (
              <HoverableTooltip
                text={this.props.titleTooltip}
                rightAligned={false}
              >
                <TouchableOpacity
                  onPress={onPressTitle}
                  onDoubblePress={onDoublePressTitle}
                >
                  {!!title?.length ? <Text>{title} </Text> : title}
                </TouchableOpacity>
              </HoverableTooltip>
            )}

            {!!firstButton && firstButton()}

            {moments?.map((moment, i) => {
              if (showMore || !maxLength || i < maxLength)
                return this.renderNode(moment, i);
            })}

            {overflowing && !showMore && (
              <Text
                style={{ ...styleSheet.bullet, width: "auto" }}
                onPress={() => this.setState({ showMore: true })}
              >
                +{overflowingBy}
              </Text>
            )}

            {button}

            {/*secondaryValues.map((node, i) => {
              return this.renderNode(node, i, { opacity: 0.5 });
            })*/}
          </MaybeScrollView>

          {!!selectedMoment &&
            (!!selectedMoment?.category ? (
              <EventEditor
                key={selectedMoment.timestamp}
                category={selectedMoment.category}
                timestamp={selectedMoment.timestamp}
                value={selectedMoment.value}
                onClose={() => {
                  this.setState({ selectedMoment: null });
                  // update chapter or something?
                }}
                composer={selectedMoment.composer}
              />
            ) : (
              <MomentBullet
                key={selectedMoment?.value.id}
                moment={selectedMoment}
                // value={item.value}
                chapter={this.props.chapter}
                rootChapter={this.props.rootChapter}
                chapterMoments={this.props.chapterMoments}
                onRefreshChapter={this.props.onRefreshChapter}
                onUpdateChapter={this.props.onUpdateChapter}
                expanded={this.props.autoExpandMoment}
                onUpdateChapter={this.props.onUpdateChapter}
                includeAttribution={this.props.includeAttribution}
              />
            ))}

          {/*!!selectedMoment && (
            <ValueListItem
              value={selectedMoment.value}
              // onSubmit={() => valueActions.progress(item.id)}
              // onSubmit={() => chapterActions.pinValue(chapterId, item.id)}
            />
          )*/}
        </View>
      );
    }
    return null;
  }

  renderNode = (moment, i) => {
    let { smallBadges, tags, doublePressActions, fade, moments } = this.props;
    let { selectedMoment } = this.state;
    if (!moment) console.log("missing moment?", this.props.chapter, moments);
    if (!moment) return null;
    let value = moment.value;
    // console.log(moment, node);
    // return (
    // <Draggable key={i}>
    // {(isDragging) => {

    let isSelected =
      !!selectedMoment?.value?.id && selectedMoment.value.id == moment.value.id;

    const Elem = tags ? Tag : Badge;

    return (
      <Hoverable
        key={i}
        // onHoverIn={() => {
        //  // this.handleHoverIn(uKey, nextGen.length);
        //  // this.props.hoverIn && this.props.hoverIn(value);
        // }}
        // onHoverOut={async () => {
        // // this.handleHoverOut(uKey, nextGen.length);
        // // this.props.hoverOut && this.props.hoverOut(value);
        // }}
      >
        {(isHovered) => {
          if (moment.category == "placeholder") isHovered = false;
          let badgeIsParentMomentsProgress = false;
          if (
            !!this.props.moment?.completed_at &&
            moment.category == "progress" &&
            textHelpers.formatDate(this.props.moment.completed_at) ==
              textHelpers.formatDate(value.timestamp)
          ) {
            badgeIsParentMomentsProgress = true;
          }
          return (
            <View
              key={i}
              style={[
                // i > 0 && { marginLeft: sizes.small },
                { marginRight: smallBadges ? sizes.tiny : sizes.small },
                isHovered && { zIndex: 1 },
                fade && { opacity: (moments.length - i) / moments.length },
              ]}
            >
              <Elem
                value={value}
                moment={moment}
                chapter={this.props.chapter}
                statusOverride={isSelected ? "completion" : undefined}
                highlighted={
                  badgeIsParentMomentsProgress ||
                  selectedMoment?.placeholderIndex == i ||
                  (!!selectedMoment?.category && isSelected)
                }
                style={{ marginHorizontal: 0 }}
                onDoublePress={
                  !doublePressActions?.length
                    ? null
                    : async () => {
                        let subtitle = ENV.WEB
                          ? null
                          : value.title || value.text;
                        let res = await alertActions.confirm({
                          options: doublePressActions,
                          title: "Take Action",
                          subtitle,
                        });
                        this.handleActionRes(value, res, doublePressActions);
                      }
                }
                onPress={() => {
                  if (moment.category == "placeholder") {
                    if (
                      this.props.allowProgressOnPressPlaceholder &&
                      !selectedMoment
                    ) {
                      this.setState({
                        selectedMoment: {
                          placeholderIndex: i,
                          category: "composer",
                          timestamp: new Date(),
                          composer: true,
                          value: {
                            color: this.props.valueColor,
                            valueId:
                              value.id || value.valueId || value.value_id,
                            timestamp: new Date(),
                          },
                        },
                      });
                      return;
                    }
                    this.setState({ selectedMoment: null });
                    return;
                  }
                  console.log(moment, value);
                  let isSelected =
                    !!selectedMoment?.id && selectedMoment.id == moment.id;
                  // if (
                  //   (!!selectedMoment?.id && selectedMoment?.id == moment.id) ||
                  //   (!!selectedMoment?.value?.id &&
                  //     selectedMoment.value.id == value.id)
                  // ) {
                  if (isSelected) {
                    this.setState({ selectedMoment: null });
                    console.log("clearing slection");
                  } else {
                    this.setState({ selectedMoment: moment });
                    console.log("selectin", moment);
                  }
                }}
                mobileLarge
                small={smallBadges || tags}
                noTooltip={moment.category == "placeholder"}
                tooltipText={
                  moment.category == "progress"
                    ? textHelpers.fullDateTime(moment.timestamp)
                    : undefined
                }
                // isHovered={isHovered}
                // name={valueHelpers.getIcon(node)}
                // // color={valueHelpers.getColor(node)}
                // color={valueHelpers.colorAsHex(node.color)}
                // size={size}
                // style={[
                //   isDragging || (isHovered && styles.draggingIcon),
                // style={
                //   isDragging || isHovered
                //     ? {
                //         backgroundColor: colors.empty,
                //         transform: [{ scale: 1.5 }],
                //         // padding: sizes.small,
                //       }
                //     : {}
                // }
                icon
              />
            </View>
          );
        }}
      </Hoverable>
    );
    //}}
    //</Draggable>
    //);
  };

  handleActionRes = async (value, res, options) => {
    let { chapter } = this.props;
    let i = res - 1;
    let actionRes;
    if (options[i] == "Pin") {
      let actionRes = await chapterActions.pinValue(chapter.id, value.id);
    } else if (options[i] == "Dismiss") {
      actionRes = await chapterActions.dismissSuggestion(chapter, value.id);
    } else if (options[i] == "Snooze") {
      alert("Snooze for how long?");
    }
  };
}

const styles = StyleSheet.create({
  wrapper: {
    // paddingHorizontal: sizes.small,
    // backgroundColor: colors.fill,
    // borderRadius: sizes.smallBorderRadius,
  },
  topMargin: {
    // marginTop: sizes.base,
  },
  row: {
    // padding: sizes.base,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    // width: 400,
    borderRadius: sizes.large,
  },
});
